module.exports = __webpack_public_path__ + "static/media/robot-welcome.3c0fda96.svg";